import React from 'react';
import Currency from '../../common/intl/Currency';
import { Dagger } from '../../common/notifications/NotificationsTrigger';
import { useNotifications } from '../../common/notifications/NotificationsContext';

export const Price = ({ children, value }) => (
  <div className="math-box__price">
    {children || <Currency value={value} />}
  </div>
);

const PriceWithNotification = ({ children, value, onClick }) => (
  <div className="math-box__price disclaimer" onClick={onClick}>
    {children || <Currency value={value} />} <Dagger />
  </div>
);

const PriceWithSymbol = ({ children, value, symbol }) => {
  const Symbol = symbol || Dagger;
  return (
    <div className="math-box__price">
      {children || <Currency value={value} />} <Symbol disabled={true} />
    </div>
  );
};

export const PriceWithConditionalNotification = props => {
  const { notificationName, inlineNotification } = props;
  const { disabled, showNamed } = useNotifications();

  if (disabled) {
    return <Price {...props} />;
  }

  if (!inlineNotification) {
    return (
      <PriceWithNotification
        {...props}
        onClick={event => showNamed(notificationName, event)}
      />
    );
  }

  return <PriceWithSymbol {...props} />;
};
